import { render, staticRenderFns } from "./tail_menu_phone.vue?vue&type=template&id=3eb02b44&scoped=true"
import script from "./tail_menu_phone.vue?vue&type=script&lang=js"
export * from "./tail_menu_phone.vue?vue&type=script&lang=js"
import style0 from "./tail_menu_phone.vue?vue&type=style&index=0&id=3eb02b44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb02b44",
  null
  
)

export default component.exports